<div class="sd-container--variant-border-neutral-400">
    <ng-container #container></ng-container>
    
    @if(content.isLoading()) {
        <div class="full">
            <sd-6-17-1-loader color="primary"></sd-6-17-1-loader>
        </div>
    } @else if(content.error()) {
        <div class="full">
            Fehler!
        </div>
    }
</div>
